import React, { useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

/** Fetch published before/after cases (optionally filtered by treatment). */
export const useGallery = (treatment) => {
  const [state, setState] = useState({ cases: [], treatments: [], loading: true, error: null });
  useEffect(() => {
    let alive = true;
    const qs = treatment ? `?treatment=${encodeURIComponent(treatment)}` : '';
    fetch(`${API}/api/gallery${qs}`)
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`))))
      .then((d) => alive && setState({ cases: d.cases || [], treatments: d.treatments || [], loading: false, error: null }))
      .catch((e) => alive && setState({ cases: [], treatments: [], loading: false, error: e.message }));
    return () => { alive = false; };
  }, [treatment]);
  return state;
};

export const imgUrl = (path) => (path?.startsWith('http') ? path : `${API}${path}`);

/**
 * Accessible before/after slider: drag handle, range input for keyboard, tap-to-toggle labels.
 */
const BeforeAfterSlider = ({ before, after, alt, width, height, className = '' }) => {
  const [pos, setPos] = useState(50);
  return (
    <div className={`relative select-none overflow-hidden rounded-xl bg-gray-100 ${className}`} style={{ aspectRatio: width && height ? `${width} / ${height}` : '4 / 3' }} data-testid="before-after-slider">
      <img src={imgUrl(after)} alt={`${alt} — after treatment`} width={width} height={height} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" draggable="false" />
      <img
        src={imgUrl(before)}
        alt={`${alt} — before treatment`}
        width={width}
        height={height}
        loading="lazy"
        decoding="async"
        className="absolute inset-0 w-full h-full object-cover"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
        draggable="false"
      />
      <div className="absolute inset-y-0 w-0.5 bg-white shadow-[0_0_0_1px_rgba(0,0,0,0.15)] pointer-events-none" style={{ left: `${pos}%` }} aria-hidden="true">
        <span className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-10 h-10 rounded-full bg-white shadow-lg flex items-center justify-center text-rabbit text-xs font-bold">⇔</span>
      </div>
      <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-rabbit/85 text-white text-xs font-semibold pointer-events-none">Before</span>
      <span className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-burnt-coral/90 text-white text-xs font-semibold pointer-events-none">After</span>
      <input
        type="range"
        min="0"
        max="100"
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        aria-label={`Compare before and after: ${alt}`}
        className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize"
        data-testid="before-after-range"
      />
    </div>
  );
};

export default BeforeAfterSlider;
